/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Shot_Source_TitleInputs */



/**
* | output |
* | --- |
* | "Shot Change Data" |
*
* @param {Ad_Shot_Source_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_shot_source_title = /** @type {((inputs?: Ad_Shot_Source_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Shot_Source_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Données de changement de tir")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schusswechseldaten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dati sulla modifica dello scatto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Данные об изменении удара")
	if (locale === "es") return /** @type {LocalizedString} */ ("Datos de cambio de disparo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("投篮变化数据")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ショット変更データ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शॉट परिवर्तन डेटा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Dados de alteração de tiro")
	return /** @type {LocalizedString} */ ("Shot Change Data")
});